import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogHeader,
    DialogFooter,
} from "@/components/ui/dialog";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { Branches } from "@/v2/constants";

export default function PrintAddressDialog({
    open,
    setOpen,
    branch,
    setBranch,
    onConfirmPrint,
}: {
    open: boolean;
    setOpen: (value: boolean) => void;
    branch: Branches;
    setBranch: (value: Branches) => void;
    onConfirmPrint: () => void;
}) {
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Before printing</DialogTitle>
                </DialogHeader>
                <div className="py-4">
                    <label className="mb-2 block text-sm font-medium">
                        Select Branch
                    </label>
                    <Select value={branch} onValueChange={setBranch}>
                        <SelectTrigger>
                            <SelectValue placeholder="Select a branch" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="YANBU">YANBU</SelectItem>
                            <SelectItem value="JUBAIL">JUBAIL</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => setOpen(false)}>
                        Cancel
                    </Button>
                    <Button onClick={onConfirmPrint}>Generate PDF</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
